<template>
    <el-dialog class="haveTable" title="关联业务模板" width="80%" :close-on-click-modal="false" :visible.sync="visible">
        <div class="el-table-container">
            <el-form class="m_t1" size="mini" :model="form" :inline="true" ref="form" label-width="0px">
                <div v-for="(item, index) in form.metadataBasicDataRangeRuleDetailList" :key="index">
                    <el-form-item :prop="`metadataBasicDataRangeRuleDetailList.${index}.basicDataDetailId`"
                                  :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]">
                        <el-select v-model="item.basicDataDetailId" placeholder="请选择本模板下的元数据" filterable
                                   @change="archivesChange(item)">
                            <el-option v-for="c in config" :key="c.id" :label="c.basicRename"
                                       :value="c.id" :disabled="c.disabled"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :prop="`metadataBasicDataRangeRuleDetailList.${index}.basicCondition`"
                                  :rules="[{required: true, message: '条件不能为空', trigger: 'change'}]">
                        <el-select v-model="item.basicCondition" placeholder="请选择">
                            <el-option label="包含" value="包含"></el-option>
                            <el-option label="不包含" value="不包含"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :prop="`metadataBasicDataRangeRuleDetailList.${index}.metadataRangeIds`"
                                  :rules="[{required: true, message: '筛选值不能为空', trigger: 'change'}]">
                        <el-select class="valItem" v-model="item.metadataRangeIds" placeholder="请选择筛选值" filterable
                                   clearable multiple :multiple-limit="item.basicAssemblyId == '10' ? 1 : 0" @remove-tag="metadataRangeIdsChange($event, item)">
                            <el-option v-for="(v,i) in item.basicRangeList" :key="i" :disabled="v.rangDisabled"
                                       :label="v.basicRange"
                                       :value="v.metadataRangeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-link class="m_t1" icon="el-icon-delete" type="danger" :underline="false"
                             @click="del(index)"></el-link>
                </div>
            </el-form>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
            <el-button size="small" type="primary" @click="confirm()" v-noMoreClick :disabled="loading">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                basicDataId: '',
                form: {
                    basicDataId: '',
                    id: '',
                    whereState: '0',
                    metadataBasicDataRangeRuleDetailList: [],
                    metadataBasicDataRangeRuleValueList: [],
                    ruleDefaultValue: [],
                }
            }
        },
        methods: {
            init(basicDataId) {
                this.visible = true
                this.form.basicDataId = basicDataId
                this.$nextTick(() => {

                })
            },
            // 选择元数据
            archivesChange(item) {

            },
            // 确定
            confirm() {
            },

        }
    }
</script>

<style scoped>

</style>
